import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RiceMethodLandingPage from "@/pages/RiceMethodLandingPage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RiceMethodLandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#1c1917",
            color: "#fafaf9",
            border: "1px solid rgba(252, 211, 77, 0.25)",
          },
        }}
      />
    </div>
  );
}

export default App;
